import { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { CheckCircle, ArrowRightCircle, MoveRight, MapPin } from 'lucide-react';

const TimelinePopup = ({ data, onClose }) => {
  const popupRef = useRef(null);

  useEffect(() => {
    gsap.fromTo(
      popupRef.current,
      { y: '100%', opacity: 50 },
      { y: 0, opacity: 1, duration: 0.5, ease: 'power3.out' }
    );
  }, []);

  return (
<div className="fixed inset-0  backdrop-blur-sm bg-opacity-40 z-50 flex items-end justify-center">
  <div
    ref={popupRef}
    style={{boxShadow:"1px -4px 20px 4px"}}
    className="bg-white rounded-t-2xl p-6 w-full max-w-md shadow-xl relative"
  >
    <button onClick={onClose} className="absolute top-2 right-3 text-gray-600 text-xl">✕</button>
    <h2 className="text-lg font-semibold mb-4 text-center">Vehicle Status</h2>

    {/* Vertical Timeline */}
    <div className="relative pl-6">
      {/* Vertical line */}
      <div className="absolute left-3 top-3 bottom-3 w-px bg-gray-300"></div>

      {/* Assigned */}
      <div className="flex items-start gap-3 relative mb-6">
        <div className="z-10 bg-white">
          <CheckCircle className="text-blue-500 w-5 h-5" />
        </div>
        <div>
          <p className="text-sm font-semibold">Accepted at</p>
          <p className="text-xs text-gray-500">{data.connectedVendorFullyTime}</p>
        </div>
      </div>

      {/* Accepted */}
      <div className={`flex items-start gap-3 relative mb-6 ${data.vendorMovedTime == null ? 'opacity-50' : ''}`}>
        <div className="z-10 bg-white">
          <ArrowRightCircle className="text-green-500 w-5 h-5" />
        </div>
        <div>
          <p className="text-sm font-semibold">Moved at</p>
          <p className="text-xs text-gray-500">{data.vendorMovedTime}</p>
        </div>
      </div>

      {/* Moved */}
      <div className={`flex items-start gap-3 relative mb-6 ${data.vendorReachedTime == null ? 'opacity-50' : ''}`}>

        <div className="z-10 bg-white">
          <MoveRight className="text-yellow-500 w-5 h-5" />
        </div>
        <div>
          <p className="text-sm font-semibold">Reached at</p>
          <p className="text-xs text-gray-500">{data.vendorReachedTime}</p>
        </div>
      </div>

      {/* Reached */}
      <div className={`flex items-start gap-3 relative mb-6 ${data.doneWorkingTime == null ? 'opacity-50' : ''}`}>
        <div className="z-10 bg-white">
          <MapPin className="text-purple-500 w-5 h-5" />
        </div>
        <div>
          <p className="text-sm font-semibold">Work done at</p>
          <p className="text-xs text-gray-500">{data.doneWorkingTime}</p>
        </div>
      </div>
    </div>
  </div>
</div>

  );
};

export default TimelinePopup;
